{{#each images}}
  {{#if path}}
    {{#if before}}
      <span {{#if before.class}}class="{{before.class}}"{{/if}}>{{t before.description}}</span>
    {{/if}}
    <picture>
      {{#each source}}
        <source media="{{media}}" srcset="{{assetPath path}}">
      {{/each}}
      <img
        class="{{class}}"
        src="{{path}}"
        role="img"
        id="{{id}}"
        alt="{{{pt description}}}"
        {{#if animation}}data-anijs="{{animation}}"{{/if}}
        {{#if width}}width="{{width}}"{{/if}}
        {{#if height}}height="{{height}}"{{/if}}
        {{#if srcset}}srcset="{{srcset}}"{{/if}}
        {{#if sizes}}sizes="{{sizes}}"{{/if}}
      />
    </picture>
    {{#if description}}{{f 'editlocaleplain' description ../cid ../forge_path 'alt tag'}}{{/if}}
    {{#if after}}
      <span {{#if after.class}}class="{{after.class}}"{{/if}}>{{t after.description}}</span>
    {{/if}}
  {{else}}
    <div {{#if animation}}data-anijs="{{animation}}"{{/if}} class="{{class}}" id="{{id}}"> </div>
  {{/if}}
{{/each}}
